import { useLocation } from 'react-router-dom';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  logo: { display: 'flex', margin: 'auto', marginTop: '50px', marginBottom: '25px' },
  mail: { display: 'flex', margin: 'auto', marginTop: '50px', marginBottom: '25px' },
  signIn: { marginTop: '5vh' },
  headingBox: { textAlign: 'center' },
}));

type LocationState = {
  title: string;
};

const Banner = () => {
  const classes = useStyles();
  const { state } = useLocation<LocationState>(); // access the state from the router history

  return (
    <div className={classes.headingBox}>
      <img src={'/logo-light-stacked.svg'} alt="Trustate Logo" className={classes.logo} />
      <img src={'/mail.svg'} alt="Trustate Products" className={classes.mail} />
      <div className={classes.signIn}>
        <Typography variant="h4" style={{ marginBottom: '15px' }}>
          {state?.title ?? 'Get help signing in'}
        </Typography>
        <Typography style={{ display: 'inline', paddingLeft: '10px', paddingRight: '10px' }}>
          Enter your email address and we will send you a reset link
        </Typography>{' '}
      </div>
    </div>
  );
};

export default Banner;
